// This file is automatically generated. Do not edit manually.

import { PartConfigurationBomLineInspectionDto } from "src/api/generated/erp/configurator/api/partConfigurationBomLineInspectionDto";
import { PartConfigurationBomLine } from "src/api/generated/erp/db/types/tables/partConfigurationBomLine";
import { ConfigurationManualEditContext } from "src/api/generated/erp/configurator/manualEdit/configurationManualEditContext";
import { BomLineGroup } from "src/api/generated/erp/db/types/tables/bomLineGroup";
import { PartConfigurationOperationView } from "src/api/generated/erp/db/types/tables/partConfigurationOperationView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationBomApi {
	export async function getPartConfigurationBomLines(args: {
		partConfigurationId: number;
		searchQuery?: string;
	}): Promise<Array<PartConfigurationBomLineInspectionDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/bom/getPartConfigurationBomLines",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<PartConfigurationBomLineInspectionDto>;
	}

	export async function getFormInitData(args: {
		partConfigurationId: number;
	}): Promise<PartConfigurationBomApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/bom/getFormInitData",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response as PartConfigurationBomApi_FormInitData;
	}

	export async function saveBomLine(args: {
		partConfigurationBomLine: PartConfigurationBomLine;
		manualEditContext?: ConfigurationManualEditContext | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/bom/saveBomLine",
			method: "POST",
			data: {
				partConfigurationBomLine: args.partConfigurationBomLine,
				manualEditContext: args.manualEditContext,
			},
		});
		return response as number;
	}

	export async function deleteBomLines(args: {
		partConfigurationBomLineIds: Array<number>;
		manualEditContext?: ConfigurationManualEditContext | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/bom/deleteBomLines",
			method: "POST",
			data: {
				partConfigurationBomLineIds: args.partConfigurationBomLineIds,
				manualEditContext: args.manualEditContext,
			},
		});
		return response as void;
	}
}

export interface PartConfigurationBomApi_FormInitData {
	bomLineGroupOptions: Array<BomLineGroup>;
	defaultReferenceNo: number;
	operationOptions: Array<PartConfigurationOperationView>;
}
